import { render, staticRenderFns } from "./ConfigurableTableColumns.vue?vue&type=template&id=8c5c3e60&scoped=true"
import script from "./ConfigurableTableColumns.vue?vue&type=script&lang=js"
export * from "./ConfigurableTableColumns.vue?vue&type=script&lang=js"
import style0 from "./ConfigurableTableColumns.vue?vue&type=style&index=0&id=8c5c3e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5c3e60",
  null
  
)

export default component.exports